import { VERIFY_AND_SENT_OTP, VERIFY_AND_SENT_OTP_SUCCESS, VERIFY_AND_SENT_OTP_ERROR, VERIFY_AND_SENT_OTP_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const VerifyAndSentOtp = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_AND_SENT_OTP:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VERIFY_AND_SENT_OTP_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case VERIFY_AND_SENT_OTP_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case VERIFY_AND_SENT_OTP_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default VerifyAndSentOtp;
